import type { ControlledTagTerm } from '@/types';

interface PublicItemMetadataSource {
  primaryRole?: ControlledTagTerm | null;
  tags?: ControlledTagTerm[];
}

export function getPublicPrimaryRole(item: PublicItemMetadataSource): ControlledTagTerm | null {
  return item.primaryRole ?? null;
}

export function getPublicDisplayTags(
  item: PublicItemMetadataSource,
  options: { limit?: number } = {},
): ControlledTagTerm[] {
  const limit = options.limit ?? Number.POSITIVE_INFINITY;
  const primaryRoleSlug = item.primaryRole?.slug ?? null;
  const seen = new Set<string>();
  const visibleTags: ControlledTagTerm[] = [];

  for (const tag of item.tags ?? []) {
    if (!tag.slug || tag.slug === primaryRoleSlug || seen.has(tag.slug)) {
      continue;
    }

    seen.add(tag.slug);
    visibleTags.push(tag);

    if (visibleTags.length >= limit) {
      break;
    }
  }

  return visibleTags;
}
